import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Kandidatura = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Новіціат</h1>
        <div className="text-justify hyphens-auto" id="section4">
          <div className="pt-3 pb-3">
            Після кандидатури та щирого розпізнання покликання кандидат звертається до Провінційного настоятеля з проханням прийняти його до новіціату.
          </div>
          <div className="pt-3 pb-3">
            Новіціат (від лат. noviciatus, novitiatus — «новий, недосвідчений», від novus — «новий») — це період, з якого розпочинається життя у Салезіянському Згромадженні отця Боско. Його мета — допомогти новикам глибше усвідомити власне покликання та досвідчити життя спільноти у молитві, служінні та братерстві.
          </div>
          <div className="pt-3 pb-3">
            Новіціат триває один рік. Канонічний дім та магістра новиків призначає Генеральний настоятель з Риму. Нині таким домом є Колле дон Боско у провінції Кастельнуово Дон Боско (Італія, П’ємонт).
          </div>
          <div className="pt-3 pb-3">
            Протягом року новики проходять формаційно-пізнавальну програму, що охоплює різні аспекти розвитку: загальнолюдський, духовний та інтелектуальний. Вони навчаються жити євангельськими радами — чистоти, послуху та убогості. Вивчають та поглиблюють Статути та правила Згромадження.
          </div>
          <div className="pt-3 pb-3 pt-3 pb-3 font-semibold text-[#A81414]">
            Для складання обітів після завершення новіціату новик повинен виявити:

          </div>
          <ul className="pl-6 list-disc">
            <li className="pt-1 pb-1">любов до Христа;</li>
            <li className="pt-1 pb-1">глибоке молитовне життя;</li>
            <li className="pt-1 pb-1">готовність до жертовного служіння молоді у дусі святого Івана Боско;


            </li>
            <li className="pt-1 pb-1">бажання служити іншим і співпрацювати у спільноті;


            </li>
            <li className="pt-1 pb-1">внутрішню певність у покликанні вступити до Салезіянського Згромадження;


            </li>
            <li className="pt-1 pb-1">чітке усвідомлення змісту обітів чистоти, послуху й убожества та здатність жити ними у спільноті.</li>
            <div className="pt-3 pb-3 pt-3 pb-3 font-semibold text-[#A81414]">
              📍 Новіціат: Колле дон Боско, провінція Кастельнуово Дон Боско (Італія, П’ємонт)


            </div>

          </ul>


        </div>
      </div>
    </>
  );
};

export default Kandidatura;
